import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const addFAQService = (body) => {
  return realBricksApi.post(`${API_ENDPOINTS.FAQS.GetFAQ}`, body);
};

export const getFAQListService = (
  isPaginated,
  page,
  limit,
  sortField,
  sortType,
  search
) => {
  let queryString = '';

  const queryParams = isPaginated
    ? `?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`
    : `?sortField=${sortField}&sortType=${sortType}`;

  return realBricksApi.get(`${API_ENDPOINTS.FAQS.GetFAQ}${queryParams}`, {
    params: {
      ...(search && { search }),
    },
  });
};
export const updateFAQService = (body) => {
  return realBricksApi.put(`${API_ENDPOINTS.FAQS.GetFAQ}`, body);
};

export const getFAQByIdService = (faqId) => {
  return realBricksApi.get(`${API_ENDPOINTS.FAQS.GetFAQ}/${faqId}`);
};

export const deleteFAQService = (faqId) => {
  return realBricksApi.delete(`${API_ENDPOINTS.FAQS.GetFAQ}/${faqId}`);
};

export const updateFAQOrderService = (body) => {
  return realBricksApi.put(`${API_ENDPOINTS.FAQS.UpdateFAQOrder}`, body);
};
